export const EXPERIMENT_CUPONS_OTIMIZACAO = 'cupons-otimizacao-seo-e-conversao';

export const NATURES = ['view', 'click', 'try'];

/**
 * Required properties per event nature.
 * Keys with array values validate against that set.
 * Keys with null value require presence only (free-form).
 */
export const REQUIRED_PROPERTIES = {
  view: {
    type: ['screen', 'component', 'modal', 'banner'],
    source: ['navigation', 'scroll', 'push', 'deep_link', 'system'],
  },
  click: {
    target: ['button', 'card', 'link', 'input', 'filter', 'tab'],
    context: null,
  },
  try: {
    trigger: ['user', 'system'],
    status: ['success', 'error', 'pending'],
  },
};

/**
 * Properties that are conditionally required.
 * Format: { nature: { property: { when: { field, value } } } }
 */
export const CONDITIONAL_PROPERTIES = {
  try: {
    message: { when: { field: 'status', value: 'error' } },
  },
};
